<template>
    <v-container fluid>
        <v-row cols="12" dense>
            <v-col cols="5">
                <h2>{{ this.title }}</h2>
            </v-col>
            <v-col cols="5">
                <btn_component data="" type="text" text="Add" icon="mdi-plus" tooltip="Add question" size="small" @actionClick="addUserQuestion"/>
            </v-col>
            <v-col cols="1">
                <btn_component data="" type="text" text="Prompts" tooltip="Update prompts" size="small" @actionClick="stdPrompts"/>
            </v-col>
            <v-col cols="1">
                <btn_component data="" type="text" text="Close" tooltip="Back to pending questions" size="small" @actionClick="pendingQuestions"/>
            </v-col>
        </v-row>
        <v-row dense cols="12">
            <v-col cols="2" class="pt-2">
                <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail dense/>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="status" :items="statusses" item-value="Option" item-text="Description"  label="Status" small-chips multiple clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="rating" :items="ratings" item-value="Option" item-text="Description" label="Rating" small-chips multiple clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="category" :items="categories" item-value="Option" item-text="Description" label="Category" small-chips multiple clearable dense></v-select>
            </v-col>
            <v-col cols="2" class="pt-2">
                <v-select v-model="source" :items="sources" item-value="Option" item-text="Description" label="Source" small-chips multiple clearable dense></v-select>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="row-default">
            <v-col cols="12" class="px-2">
                <v-data-table id="x" 
                    dense 
                    :headers="getQuestionsHeaders()" 
                    :items="filteredQuestions" 
                    :disable-pagination=true
                    hide-default-footer 
                    item-key="oavr_nr" 
                    :loading="loading"
                    loading-text="Loading data...please wait" 
                    fixed-header 
                    :search="search"
                    :height="wInnerHeight"
                    >
                    <template v-slot:item="question">
                        <tr @click="procesQuestion(question.item)" >
                            <td>{{ question.item.oavr_nr }}</td>
                            <td>{{ question.item.oavr_received_dt.replace("T", " ").substring(0, 16) }}</td>
                            <td>{{ question.item.oavr_status }}</td>
                            <td>{{ question.item.oavr_rating }}</td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ question.item.oact_code }}</span>
                                    </template>
                                    <span v-if=" question.item.oact_oms!==''">{{ question.item.oact_oms }}</span>
                                </v-tooltip>                                                       
                            </td>
                            <td>{{ question.item.oavr_bron }}</td>
                            <td>
                                <v-tooltip bottom  v-if="question.item.oavr_antwoord!==''">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{ question.item.oavr_vraag }}</span>
                                    </template>
                                    <span>{{ question.item.oavr_antwoord }}</span>
                                </v-tooltip>
                                <div v-else>{{ question.item.oavr_vraag }}</div>                                  
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";

    export default {
        components: {
            btn_component,
        },    
        props: {
            wInnerHeight: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
                title: "User questions overview",
                search: "",
                text_max_width: 150,     // For all long texts
                questions: [],

                // Selected sources & source options
                source: ["user"],    
                sources: [{
                    Option: "website",
                    Description: "Website"
                }, {
                    Option: "user",
                    Description: "User"
                }],

                // Selected categories & category options
                category: [],
                categories: [],

                // Selected rating & rating options
                rating: [],
                ratings: [],

                // Selected statusses & status options
                status: [],
                statusses: [],
            }
        },    
        computed: {
            filteredQuestions: function() {            
                return this.questions.filter((question) => {
                    if (!this.match_field(this.source, question.oavr_bron)) {
                        return false;
                    }
                    if (!this.match_field(this.category, question.oact_code)) {
                        return false;
                    }
                    if (!this.match_field(this.status, question.oavr_status)) {
                        return false;
                    }
                    if (!this.match_field(this.rating, question.oavr_rating)) {
                        return false;
                    }
                   
                    return true;
                })
            }     
        },
        mounted() {
            this.getFilters();
            this.getQuestionsOverview();
        },
        methods: {
            getFilter(name, defaultValue) {
                if (sessionStorage.getItem(name) === null) {
                    return defaultValue;
                } else {
                    return JSON.parse(sessionStorage.getItem(name));
                }
            },
            getFilters() {
                this.search = sessionStorage.getItem("user_search") === null ? "" : sessionStorage.getItem("user_search");
                this.source = this.getFilter("user_source", ["user"]);
                this.category = this.getFilter("user_category", []);
                this.rating = this.getFilter("user_rating", []);
                this.status = this.getFilter("user_status", ["ExpertReview"]);
            },  
            setFilter(name, data) {
                sessionStorage.setItem(name, JSON.stringify(data));
            },
            setFilters() {
                sessionStorage.setItem("user_search", this.search);
                this.setFilter("user_source", this.source);
                this.setFilter("user_category", this.category);
                this.setFilter("user_rating", this.rating);
                this.setFilter("user_status", this.status);
            },  
            match_field(options, value) {
                if (options.length === 0) { return true } 
                for(let idx=0; idx < options.length; idx++) {                         
                    if(options[idx] === value) {
                        return true;
                    }
                }
                return false;                
            },  
            getQuestionsOverview() {
                this.loading = true;
                this.$axios.post("ares/json/ares/task/customer_success/openai/getQuestionsOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getQuestionsOverview"
                    },
                    getQuestionsOverview: {
                    }
                }).then(res => {
                    if (res.data.header.error) {
                        console.log(res.data.error);
                    } else {
                        this.categories = res.data.oact;
                        this.statusses = res.data.status_codes;
                        this.ratings = res.data.rating_codes;
                        this.questions = res.data.getQuestionsOverview;
                    }
                    this.loading = false;
                });
            },            
            getQuestionsHeaders() {
                return [
                    { text: "Nr", value: "oavr_nr", sortable: true, width: '5%' },
                    { text: "Created", value: "oavr_received_dt", sortable: true, width: '8%' },
                    { text: "Status", value: "oavr_startus", sortable: true, width: '8%' },
                    { text: "Rating", value: "oavr_rating", sortable: true, width: '8%' },
                    { text: "Category", value: "oact_code", sortable: true, width: '8%' },
                    { text: "Source", value: "oavr_bron", sortable: true, width: '8%' },
                    { text: "Question", value: "oavr_vraag", sortable: true, width: '50%' },
                ];
            },
            addUserQuestion() {
                this.$emit("updateView", -1);
            },
            procesQuestion(question) {
                this.$emit("updateView", question.oavr_nr);
            },
            stdPrompts() {
                this.setFilters();
                let route = this.$router.resolve({ path: "/task/customer_success/openai/prompts/user_questions"}); 
                window.open(route.href, '_self');
            },
            pendingQuestions() {
                this.setFilters();
                let route = this.$router.resolve({ path: "/task/customer_success/openai/questions"}); 
                window.open(route.href, '_self');
            },
        }
    }
</script>

<style scoped> 
    .row-default {
        cursor: default;
    }
    .row-pointer {
        cursor: pointer;
    }
    .subtitle-weight {
        font-weight: 400;
    }
</style>